import React, { FunctionComponent, useCallback } from 'react'
import { Popup } from '@/components/Popup'
import { Button } from '@/components/Button'

import styles from './AcceptPopup.module.scss'

interface AcceptPopupProps {
  onClose: (value: boolean) => void
  data: {
    title?: string
    description?: string
    cancelButton?: string
    acceptButton?: string
  }
}
export const AcceptPopup: FunctionComponent<AcceptPopupProps> = ({
  onClose,
  data,
}) => {
  const accept = useCallback(() => {
    onClose(true)
  }, [onClose])

  const cancel = useCallback(() => {
    onClose(false)
  }, [onClose])
  return (
    <Popup onClose={cancel}>
      <div className={styles.container}>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        {data.description ? (
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        ) : null}
        <div className={styles.buttons}>
          {data.cancelButton != null ? (
            <Button
              className={styles.button}
              name={data.cancelButton}
              onClick={cancel}
              variant="secondary"
            />
          ) : null}
          {data.acceptButton != null ? (
            <Button
              className={styles.button}
              name={data.acceptButton}
              onClick={accept}
              variant="primary"
              isNegative
            />
          ) : null}
        </div>
      </div>
    </Popup>
  )
}
